import { delay } from "@/hooks/useReveal";
import { BookingLink } from "./BookingLink";

const STATS = [
  ["14 years", "in EU law, from Brussels to Croatia"],
  ["5,000+", "EU law advisories delivered"],
  ["1 unicorn", "built on legal foundations we laid"],
  ["3 languages", "English, Italian, Croatian"],
];

const BridgeVisual = () => (
  <div className="hero__visual" data-reveal style={delay(2)} data-testid="hero-visual">
    <svg viewBox="0 0 520 280" fill="none" role="img" aria-label="A bridge connecting your growth to regulation">
      <path className="hero__arch" d="M40 200 Q260 -10 480 200" stroke="#E0A33B" strokeWidth="6" strokeLinecap="round" />
      <path d="M20 200 L500 200" stroke="#E0A33B" strokeWidth="4" strokeLinecap="round" />
      <path d="M120 200 L120 132 M190 200 L190 92 M260 200 L260 80 M330 200 L330 92 M400 200 L400 132" stroke="#E0A33B" strokeWidth="2" strokeLinecap="round" opacity=".6" />
      <rect x="20" y="200" width="70" height="40" rx="4" fill="#0B1B33" />
      <rect x="430" y="200" width="70" height="40" rx="4" fill="#0B1B33" />
    </svg>
    <div className="hero__visual-labels">
      <span>Your growth</span><span>Regulation</span>
    </div>
  </div>
);

export const Hero = () => (
  <section id="top" className="hero surface-dark" aria-labelledby="hero-title" data-testid="hero-section">
    <div className="container hero__grid">
      <div className="hero__copy" data-reveal>
        <p className="eyebrow">EU AI Act governance for growing companies</p>
        <h1 id="hero-title" className="hero__title" data-testid="hero-title">The bridge between your growth and <em>regulation</em>.</h1>
        <p className="hero__lead">One team that understands both law and technology. We bring in verified AI tools and hold the legal side, so your team can adopt AI without waiting on the paperwork.</p>
        <div className="hero__actions">
          <BookingLink className="btn btn--lg btn--amber" testId="hero-cta-book">Book a 30-min AI check</BookingLink>
          <a className="btn btn--lg btn--ghost-light" href="#licence" data-testid="hero-cta-licence">See the licence</a>
        </div>
        <p className="hero__note">The call is free. If you don't need an AI officer, we'll tell you.</p>
      </div>
      <BridgeVisual />
    </div>
    <div className="container">
      <ul className="stats" aria-label="At a glance" data-testid="hero-stats">
        {STATS.map(([value, label], i) => (
          <li key={value} data-reveal style={delay(i + 3)}><span className="stats__value">{value}</span><span className="stats__label">{label}</span></li>
        ))}
      </ul>
    </div>
  </section>
);
